import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';

import { LotWatchRequestTimeLimitService } from '../../../services/lot-watch-request-time-limit.service';

import { LotWatchRequestFormModalComponent } from './components/lot-watch-request-form-modal/lot-watch-request-form-modal.component';
import { LotWatchRequestButtonComponent } from './lot-watch-request-button.component';

@NgModule({
  declarations: [LotWatchRequestButtonComponent, LotWatchRequestFormModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    NzButtonModule,
    NzModalModule,
    NzAlertModule,
    NzImageModule,
    NzSkeletonModule,
    NzDividerModule,
    ReactiveFormsModule,
    NzInputModule,
    NzFormModule,
  ],
  exports: [LotWatchRequestButtonComponent],
  providers: [LotWatchRequestTimeLimitService],
})
export class LotWatchRequestButtonModule {}
